export interface ICubeSchemaMapper {
  persistenceToDomain(model: any): any;
  domainToRest(entity: any): any;
}
